import { AUTH_SCOPES } from './constants'
import type { AuthScope } from './types'

export default function isWorldsAuthScope(authScope: string): authScope is AuthScope {
  return AUTH_SCOPES.includes(authScope as AuthScope)
}
